import { Collapse } from "@mui/material";
import React from "react";

import IMedicalFormElementProps from "../types/IMedicalFormElement";
import IMedicalQualification from "../types/IMedicalQualification";

export interface ICollapsingDisabledMedicalQuestionDecoratorConfig {
  /** Callback to determine if the question should be collapsed. */
  isDisabled: (formState: IMedicalQualification) => boolean;
  /** The decorated form item component to be rendered within the collapse. */
  ChildFormItem: React.FC<IMedicalFormElementProps>;
}

/** A medical question decorator which controls disabling the question by hiding the inner form element via the
 * collapse animation.
 */
const CollapsingDisabledMedicalQuestionDecorator: React.FC<
  ICollapsingDisabledMedicalQuestionDecoratorConfig & IMedicalFormElementProps
> = ({ value, isDisabled, ChildFormItem, ...rest }) => (
  <Collapse in={!isDisabled(value)}>
    <ChildFormItem {...rest} value={value} />
  </Collapse>
);

export default CollapsingDisabledMedicalQuestionDecorator;
